export default "__VITE_ASSET__LFpw7cWC__"